import React from 'react'

export const TableContainer = ({ children }) => {
  return <div>{children}</div>
}
